import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { getCurrentUserAsync } from './services/entraIdService'

// Inicializar MSAL y procesar redirecciones antes de montar React (evita que React Router interfiera con el hash de la URL)
(async () => {
  try {
    await getCurrentUserAsync();
  } catch (err) {
    console.error("Error al inicializar MSAL en main.tsx:", err);
  } finally {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }
})();
